import React from "react";
import styles from "./index.module.scss";
import clsx from "clsx";
import translate from "../../../../i18n/translate";
import {useSelector} from "react-redux";
import {FaBan} from "react-icons/fa";
import {formatPrice} from "../../../../utils/formatPrice";
import {formatPriceParking} from "../../../../utils/formatPriceParking";
import {parseFormattedNumber} from "../../../../utils/parseFormattedNumber";
import {Space} from "antd";

export default function Parking({ parking, onParkingClick, classNames, smallChess }) {
  const {rate} = useSelector(state => state.rate)

  const totalPrice = parking.price || (parking.m2 * parking.pricePerMetrSquare);

  return (
    <div
      className={clsx(styles["apartment-container"], ...classNames)}
      onClick={onParkingClick}
      style={{
        ...(smallChess
            ? { width: "50px", height: "50px" }
            : {}),
      }}
    >
      {smallChess ? (
        <div className={styles.smallChess}>
          <p>{parking.number}</p>
        </div>
      ) : (
          <>

              <p>
                  &#8470;
                  {/*{translate("apartment.apartment_number")}{" "}*/}
                  {" "}
                  <b>{parking.number}</b>
              </p>
              <p>

                  {/*{translate("apartment.apartment_number")}{" "}*/}
                  {" "}
                  <b>{parseFloat(parking.m2)}{translate("misc.sqm")}</b>
              </p>
              {parking.storageRoomM2 && (
                  <p>
                      {translate("menu.storage_room")}{" "}
                      <b>{parseFloat(parking.storageRoomM2)}{translate("misc.sqm")}</b>
                  </p>
              )}


              {
                  parking.orders[0]?.type === "sold" ?
                      <>
                      <p className={styles['apartment-sold']}>
                          {translate("status.sold")}
                      </p>
                          <Space>
                              <b>{translate("sale.user")}</b>
                              <p>
                                  {parking.orders[0]?.user?.username}{" "}

                              </p>
                          </Space>
                          <br/>
                          <Space>
                              <b>{translate("sale.customer_name")}</b>
                              <p  style={{wordBreak: "break-all"}}>
                                  <span className={styles.lineClamp}>
                                  {parking.orders[0]?.client?.customerName}
                                  </span>
                              </p>
                          </Space>
                      </>
                      :
                      <p>
                          {/*{translate("apartment.price")}{" "}*/}
                          <b>{(() => {
                              const parkingPrice = parseFormattedNumber(formatPriceParking(parking, rate));
                              const storagePrice = parking?.storageRoomM2 && parking?.storageRoomPriceMetr
                                  ? Math.round(parking.storageRoomM2 * parking.storageRoomPriceMetr * rate * 10) / 10
                                  : 0;
                              return (parkingPrice + storagePrice).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
                          })()} {translate("misc.currency")}</b>
                      </p>
              }

          </>
      )}
    </div>
  );
}